<template>
  <div id="jumbotron">
    <div class="container">
      <h1 v-html="$t('programsPage.title')"></h1>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          {{ $t('programsPage.englishPrograms.title') }}
        </h2>
        
        <p>
          {{ $t('programsPage.englishPrograms.description') }}
        </p>

        <ul v-html="$t('programsPage.englishPrograms.points')"></ul>

        <router-link class="btn btn-secondary me-4 px-4" to="/english-classes">
          {{ $t('programsPage.learnMore') }}
        </router-link>
      </div>
    </div>
  </div>

  <div class="bg-color">
    <div class="container py-5 my-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            {{ $t('programsPage.newLanguages.title') }}
          </h2>
          <p v-html="$t('programsPage.newLanguages.description')"></p>
          <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/79" target="_blank">
            {{ $t('programsPage.learnMore') }}
          </a>
        </div> 
      </div>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-6">
        <h2 class="text-primary mb-4">
          {{ $t('programsPage.pdp.title') }}
        </h2>
        <p>
          {{ $t('programsPage.pdp.description') }}
        </p>
        <ul v-html="$t('programsPage.pdp.points')"></ul>
        <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/77" target="_blank">
          {{ $t('programsPage.learnMore') }}
        </a>
      </div>
      <div class="col-12 col-md-6">
        <div class="row m-0 pt-5">
          <div class="col-6">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/whale+room+01.jpeg" alt="Whale Room" class="w-100">
          </div>
          <div class="col-6">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/whale+room+02.jpeg" alt="Whale Room" class="w-100">
          </div>
          <div class="col-12 text-center pt-2">
            <p>{{ $t('programsPage.pdp.imageDesc') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-color">
    <div class="container py-5 my-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            {{ $t('programsPage.hybridIG.title') }}
          </h2>
          <p v-html="$t('programsPage.hybridIG.description')">
            
          </p>
          <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/81" target="_blank">
            {{ $t('programsPage.learnMore') }}
          </a>
        </div> 
      </div>
    </div>
  </div>

  <div class="container pt-5 mt-5">
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <h2 class="text-primary mb-4">
          {{ $t('programsPage.holidayCamps.title') }}
        </h2>
        <div v-html="$t('programsPage.holidayCamps.description')"></div>
        <a class="btn btn-secondary me-4 px-4" href="https://scholarships2u.activehosted.com/f/83" target="_blank">
          {{ $t('programsPage.learnMore') }}
        </a>
      </div>
    </div>
  </div>
  <br><br><br>
  <WhyUs />
  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 1.8em; }
h3 { font-size: 1.5em; }

.bg-color {
  background-color: #F4F3F9;
}

ul.style-type-none {
  list-style-type: none;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
import WhyUs from '../components/WhyUs.vue';
export default {
  components: { ContactUs, WhyUs }
}
</script>